import { FieldDesignChange } from '../../../../../FDCTrackerContext/types'
import { Button } from 'antd'
import { useCIMSTableContext } from 'components/CIMSTable/CIMSTableContext'
import { FieldDesignChangeStatus } from 'shared'

export const Resolution: React.FC<FieldDesignChange> = ({
  children,
  ...record
}) => {
  const { resolution, fdcToFDCApprovalGroups, deleted, statusId } = record
  const {
    modals: {
      simpleEdit: { toggle },
    },
  } = useCIMSTableContext<FieldDesignChange>()
  if (!resolution)
    return (
      <Button
        type="link"
        onClick={() => toggle(record)}
        style={{ padding: 0, height: 'auto', display: 'inline' }}
        disabled={
          !!fdcToFDCApprovalGroups.length ||
          deleted ||
          statusId === FieldDesignChangeStatus.Closed.id
        }
      >
        Add Resolution
      </Button>
    )
  return <>{resolution}</>
}

export default Resolution
